import React from 'react';
import classnames from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import s from './Page.scss';
const Page = ({ isCurrent, page, getPageUrl, onChangePage, children, biData })=>{
    const url = getPageUrl && getPageUrl(page);
    const onClick = onChangePage && (()=>onChangePage(page));
    if (isCurrent || !onClick && !url) {
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['page'], isCurrent && s['current'])
        }, children);
    }
    if (url) {
        return /*#__PURE__*/ React.createElement(BiLink, {
            biData: biData,
            className: s['page'],
            href: url,
            onClick: onClick
        }, children);
    }
    return /*#__PURE__*/ React.createElement(BiButton, {
        biData: biData,
        className: s['page'],
        onClick: onClick
    }, children);
};
Page.displayName = 'Page';
export default Page;

//# sourceMappingURL=Page.js.map